import React from 'react';
import './AboutBanner.css'
const AboutBanner = () => {
    return (
        <div className='profile-banner-container'>
            <div className="profile-banner container-fluid p-0">
                <img src={require('../../../images/about/aboutbanner.jpg')} className='h-100 w-100' alt="" />
                <div className="profile-banner-text">
                    <h1>About Us</h1>
                </div>
            </div>
        </div>
    );
};

export default AboutBanner;